import { hexToRgbChannels } from './color';
import { brand, theme } from './theme';

// Exposes the brand to plain CSS/SCSS/SVG, which cannot read the JS theme.
export function applyBrandToDocument(root: HTMLElement = document.documentElement): void {
  root.dataset.brand = brand;
  root.style.setProperty('--brand-primary', theme.colors.brand.primary);
  root.style.setProperty('--brand-primary-rgb', hexToRgbChannels(theme.colors.brand.primary));
  root.style.setProperty('--brand-primary-soft', theme.colorPrimary);
  root.style.setProperty('--brand-info', theme.colorInfo);
  root.style.setProperty('--brand-accent', theme.colors.brand.accent);
}
